
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.7 27.6H2V12.8h5.7v14.8z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M17.4 3c-.2 0-.5 0-.7.1-1.3.4-2 2-1.9 4.5.1 1.8-.3 3-1.1 3.7-1.1 1-2.9.6-2.9.6-.3-.1-.6 0-.8.2-.2.2-.4.5-.4.8v14.2c0 .4.3.8.7.9l7 2.6c.1.1 1.1.4 3.7.4h5.5c1.6 0 3-1.5 3-3.3 0-.6-.2-1.1-.4-1.6 1-.5 1.6-1.6 1.6-2.7 0-.7-.2-1.3-.6-1.8.7-.6 1.2-1.4 1.2-2.4 0-.5-.1-.9-.3-1.3 1.2-.4 2-1.6 2-2.9 0-1.7-1.4-3.1-3.1-3.1h-8.6c.7-3.3-.4-6.1-1.2-7.4-.4-.6-1.5-1.5-2.7-1.5zm-5.8 11c1 0 2.3-.2 3.4-1.1 1.3-1.1 1.9-2.9 1.8-5.3-.1-1.9.3-2.5.5-2.6.3-.1 1 .4 1.2.7 0 0 1.9 3 .6 6.9-.1.3-.1.6.1.9.2.3.5.4.8.4h9.9c.7 0 1.1.6 1.1 1.1 0 .7-.6 1.1-1.1 1.1h-1.7c-.6 0-1 .4-1 1s.4 1 1 1c.7 0 1.1.6 1.1 1.1 0 .7-.6 1.1-1.1 1.1h-.6c-.6 0-1 .4-1 1s.4 1 1 1c.7 0 1.1.6 1.1 1.1 0 .7-.6 1.1-1.1 1.1l-1.3.1c-.5 0-.9.5-.9 1s.5 1 1 1c.7 0 1.1.6 1.1 1.1 0 .7-.5 1.3-1 1.3H21c-2.2 0-3.1-.3-3.1-.3l-6.3-2.3V14z","fill":"#36C0B6"}})])
          )
        }
      }
    